ACC.applePayHelpers = {

    requestApplePayOrderInfo() {
        return $.ajax({
            url: `${ACC.config.encodedContextPath}/applePayOrderInfo/current`,
            dataType: 'json',
        });
    },

    validateBillingAddress() {
        return $.ajax(`${ACC.config.encodedContextPath}/checkout/validate/applepay/billingAddress`, {
            method: 'post',
            headers: {
                CSRFToken: ACC.config.CSRFToken,
            },
            data: ACC.applePay.billingAddressForm,
            dataType: 'html',
        });
    },

    updateShippingMethod(shippingMethodIdentifier) {
        return $.ajax({
            url: `${ACC.config.encodedContextPath}/checkout/multi/delivery-method/select`,
            data: {
                delivery_method: shippingMethodIdentifier,
            },
        });
    },

    setInitialShippingAddress() {
        return $.ajax({
            url: `${ACC.config.encodedContextPath}/applePay/deliveryAddress/setInitialShippingAddress`,
            method: 'post',
            headers: {
                CSRFToken: ACC.config.CSRFToken,
            },
            data: {
                addressId: ACC.applePay.initialShippingAddressId,
            },
        });
    },

    isInitialShippingAddress() {
        return $.ajax({
            url: `${ACC.config.encodedContextPath}/applePay/deliveryAddress/isInitialShippingAddress`,
            method: 'post',
            async: false,
            headers: {
                CSRFToken: ACC.config.CSRFToken,
            },
            data: {
                addressId: ACC.applePay.initialShippingAddressId,
            },
        });
    },

    populateOrderTotals(paymentRequest, data, lineItemsFieldName, totalFieldName) {
        const { orderTotals } = data;

        paymentRequest[lineItemsFieldName] = [
            ...(orderTotals.showDeliveryCost ? [{
                label: ACC.config.applePayShippingPriceMessage,
                amount: orderTotals.deliveryCost,
            }] : []),
            ...(orderTotals.showDiscounts ? [{
                label: ACC.config.applePayDiscountsMessage,
                amount: -orderTotals.discountAmount,
            }] : []),
            {
                label: ACC.config.applePaySubtotalMessage,
                amount: orderTotals.subtotal,
            },
            ...(orderTotals.showTax ? [{
                label: ACC.config.applePayEstimatedTaxMessage,
                amount: orderTotals.tax,
            }] : []),
        ];

        paymentRequest[totalFieldName] = {
            label: ACC.config.applePayTotalMessage,
            amount: orderTotals.totalPriceWithTax,
        };
    },

    toggleApplePayButton() {
        const applePayTerms = document.getElementById('applePayTerms');
        if (!applePayTerms) {
            return;
        }
        applePayTerms.addEventListener('change', ({ target }) => {
            const realApplePayBtn = document.querySelector('.apple-pay-button-wrapper');
            const isDisable = 'isDisable';
            if (target.checked) {
                realApplePayBtn.classList.remove(isDisable);
            } else {
                realApplePayBtn.classList.add(isDisable);
            }
        });
    },

    showApplePayBlock() {
        if (window.ApplePaySession) {
            $('.applepay-block').fadeIn();
        }
    },

    hideApplePayBlock() {
        if (window.ApplePaySession) {
            $('.applepay-block').hide();
        }
    },

    completeApplePaySession(session) {
        session.completePayment({
            status: window.ApplePaySession.STATUS_SUCCESS,
        });
    },

    failApplePaySessionWithWrongShippingAddress(session) {
        session.completePayment({
            status: window.ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS,
        });
    },

    failApplePaySessionWithWrongBillingAddress(session) {
        session.completePayment({
            status: window.ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS,
        });
    },

    failApplePaySession(session) {
        session.completePayment({
            status: window.ApplePaySession.STATUS_FAILURE,
        });
    },

    sendDataLayer() {
        window.dataLayer.push({
            event: 'paymentType',
            payment_type: 'APPLEPAY',
        });
    },
};
